import { useMutation } from "@tanstack/react-query";
import { apiConfig } from "../../config";
import ApiContactUs from "./api-contactus";
import { IPostContactUS } from "./interfaces/api-contactus-interfaces";

export const useContactUs = () => new ApiContactUs(apiConfig());
export const useContactUsPost = ({
  onSuccess,
  onError,
}: {
  onSuccess: (res: IPostContactUS) => void;
  onError: (x: any) => void;
}) => {
  const contactUs = useContactUs();
  return useMutation(
    ({
      body,
      params,
    }: {
      body: import("./interfaces/api-contactus-interfaces").IContactUSParams;
      params?: {
        fbc?: string | null;
        fbp?: string | null;
        event_id?: string;
        ttp?: string | null;
        ttclid?: string | null;
      };
    }) => contactUs.contactUs(body, params),
    {
      onSuccess: onSuccess,
      onError: onError,
    },
  );
};
